/**
 * This function is polyfilled by webpack (core-js).
 * @param {VoidFunction} callback
 * @param  {...any} args
 */
export function setImmediate(callback, ...args) {
	// @ts-ignore
	return self.setImmediate(callback, ...args);
}

/**
 * This function is polyfilled by webpack (core-js).
 * @param {any} id
 */
export function clearImmediate(id) {
	return self.clearImmediate(id);
}

/**
 * This function is polyfilled by webpack (core-js).
 * @param {VoidFunction} callback
 */
export function nextTick(callback) {
	return queueMicrotask(callback);
}

/**
 * Alternate implementation of nextTick that returns a promise.
 */
export const nextTickPromise = () => {
	return new Promise((resolve) => {
		nextTick(() => {
			resolve();
		});
	});
};

/**
 * Alternate implementation of nextTick that uses requestAnimationFrame.
 * @param {VoidFunction} callback
 */
export function nextTickFrame(callback) {
	requestAnimationFrame(callback);
}

/**
 * Alternate implementation of nextTick that returns a promise.
 */
export function nextTickFramePromise() {
	return new Promise((resolve) => {
		nextTickFrame(() => {
			resolve();
		});
	});
}

/**
 * Alternate implementation of nextTick that uses Promise.resolve.
 * @param {VoidFunction} callback
 */
export function nextTickAlt(callback = () => {}) {
	return Promise.resolve().then(callback);
}

/**
 * @param {number} ms
 */
export const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

/**
 * @param {number} ms
 * @todo Use CancelablePromise instead (import 'cancelable-promise')
 */
export const cancelableDelay = (ms) => {
	let timer;
	const cancel = () => {
		window.clearTimeout(timer);
	};
	const promise = new Promise((resolve) => {
		timer = window.setTimeout(resolve, ms);
	});
	// @ts-ignore
	promise.cancel = cancel;
	return promise;
};